/**
 * Generic placeholder data fuer die Voice-AI-Demo.
 *
 * Bewusst KEINE realen Site-Codes und keine konkreten Stadtnamen.
 *
 * Die Demo verwendet generisches Warehouse-Operations-Vokabular ohne
 * Bezug auf einen spezifischen Endkunden oder dessen interne Namen.
 */

/** Pseudonymisierte Site-Namen fuer Multi-Site-Demos. */
export const DEMO_SITES = [
  { id: "site-alpha", label: "Site Alpha", region: "EU-1" },
  { id: "site-beta", label: "Site Beta", region: "EU-1" },
  { id: "site-gamma", label: "Site Gamma", region: "EU-2" },
] as const;

/** Default-Site fuer Single-Site-Scenes. */
export const DEMO_SITE = DEMO_SITES[0];

/**
 * Generische Warehouse-Operations-Zonen. Diese Begriffe sind industry-standard
 * und beschreiben keine spezifische Site — sie funktionieren in jedem
 * grossen Distributions- oder Logistik-Zentrum weltweit.
 */
export const DEMO_ZONES = [
  { id: "inbound", label: "Inbound", color: "bg-sky-500" },
  { id: "stow", label: "Stow", color: "bg-emerald-500" },
  { id: "pick", label: "Pick", color: "bg-amber-500" },
  { id: "pack", label: "Pack", color: "bg-violet-500" },
  { id: "outbound", label: "Outbound", color: "bg-rose-500" },
  { id: "maintenance", label: "Maintenance", color: "bg-slate-500" },
] as const;

/** Generische Talkgroup-Namen — operational, keine Site-Spezifika. */
export const DEMO_TALKGROUPS = [
  { id: "ops", label: "Operations", slot: 1 },
  { id: "field-it", label: "Field IT", slot: 2 },
  { id: "shift-leads", label: "Shift Leads", slot: 1 },
  { id: "maintenance", label: "Maintenance", slot: 2 },
  { id: "loss-prevention", label: "Loss Prevention", slot: 1 },
];

/** Generische Repeater-IDs (1-4 statt Site-spezifisch). */
export const DEMO_REPEATERS = [
  { id: "RPT-01", role: "master", online: true },
  { id: "RPT-02", role: "peer", online: true },
  { id: "RPT-03", role: "peer", online: false },
  { id: "RPT-04", role: "peer", online: true },
] as const;
